import React from 'react';
import Isvg from 'react-inlinesvg';

import Confirm from 'components/Confirm';
import Message from 'components/Message';
import { ICONS } from 'constants/icons';
import { bem } from 'helpers/class-name';
import { resetCalendarSyncFlowModalMessages as messages } from '../../CalendarLinks.messages';

const { element } = bem('calendar-links-your-platform');

const ResetCalendarSyncFlowModal = () => (
  <Confirm
    title={
      <div className={element('modal-header')}>
        <Isvg className={`mr-s ${element('alert-icon')}`} src={ICONS.alert} />
        <Message message={messages.title} />
      </div>
    }
    cancelNode={<Message message={messages.cancel} />}
    acceptNode={<Message message={messages.accept} />}>
    <Message message={messages.body} />
  </Confirm>
);

export default ResetCalendarSyncFlowModal;
